import React, { Component } from 'react';
import { Grid, Divider, Container } from 'semantic-ui-react'
import { supportInfoURL } from "../../shared/urls/clientapi";
import { callService, GET } from "../../shared/serviceInvoker";

export default class OfficeDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            default_support_email: '',
            default_support_fax: '',
            default_support_phone: '',
            support_hours_from: '',
            support_hours_to: '',
        }
    }

    componentDidMount() {

        callService(
            GET,
            supportInfoURL,
            null,
            response => {
                var result = response.data.data;
                this.setState({
                    default_support_email: result.default_support_email,
                    default_support_fax: result.default_support_fax,
                    default_support_phone: result.default_support_phone,
                    support_hours_from: result.support_hours_from,
                    support_hours_to: result.support_hours_to
                });
            },
            error => {
                var result = [];
                this.setState({ data: result });
            }
        );
    }


    render() {

        return (
            <div>
                <Divider hidden />
                <Container>
                    <Grid textAlign='center'>
                        <Grid.Column style={{ maxWidth: 450 }} textAlign='left'>
                            <h2>Contact Us</h2>
                            <table className="ui very basic table">
                                <tbody>
                                <tr className="right aligned">
                                    <td colSpan="2">Customer Support: {this.state.default_support_phone}</td>
                                </tr>
                                <tr className="right aligned">
                                    <td colSpan="2"><a href={'mailto:' + this.state.default_support_email} target="_top">{this.state.default_support_email}</a></td>
                                </tr>
                                <tr className="left aligned">
                                    <td colSpan="2"><h3>Hours of Operation</h3></td>
                                </tr>
                                <tr>
                                    <td>Monday</td>
                                    <td className="right aligned">{this.state.support_hours_from} - {this.state.support_hours_to}</td>
                                </tr>
                                <tr>
                                    <td>Tuesday</td>
                                    <td className="right aligned">{this.state.support_hours_from} - {this.state.support_hours_to}</td>
                                </tr>
                                <tr>
                                    <td>Wednesday</td>
                                    <td className="right aligned">{this.state.support_hours_from} - {this.state.support_hours_to}</td>
                                </tr>
                                <tr>
                                    <td>Thursday</td>
                                    <td className="right aligned">{this.state.support_hours_from} - {this.state.support_hours_to}</td>
                                </tr>
                                <tr>
                                    <td>Friday</td>
                                    <td className="right aligned">{this.state.support_hours_from} - {this.state.support_hours_to}</td>
                                </tr>
                                <tr>
                                    <td colSpan="2"></td>
                                </tr>
                                </tbody>
                            </table>
                        </Grid.Column>
                    </Grid>
                </Container>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/OfficeDetails/index.js